import { SelectFormInput } from "components/inputs";
import {
  useContractOrderRequestShipFroms,
  useRequestOrderFormSelectedOptions,
} from "hooks/api/requestOrder";
import useSingleOptionAsFormDefault from "hooks/useSingleOptionAsFormDefault";

const ShipFromSelect = ({ id }: { id: string }) => {
  const selectedOptions = useRequestOrderFormSelectedOptions();

  const {
    data: shipFromOptions,
    isInitialLoading,
    isRefetching,
  } = useContractOrderRequestShipFroms(selectedOptions);

  useSingleOptionAsFormDefault(id, shipFromOptions);

  const isLoading = isInitialLoading || isRefetching;

  return (
    <SelectFormInput
      id={id}
      label="Ship From"
      options={shipFromOptions}
      isLoading={isLoading}
      isDisabled={isLoading || (shipFromOptions?.length ?? 0) <= 1}
      placeholder="Select location"
    />
  );
};

export default ShipFromSelect;
